import { IScreenPosition, LogoContent } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../section/Primitive"
import LinkContainer from "../useful/LinkContainer"  
import { CSSProperties } from "react"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"

/* Protopia Ecosystem component */ 
const LogoPrimitive = (props: IPrimitiveProps): JSX.Element => { 
    const {position} = usePosition( props.primitive || {position: {}} )
    const primitive: LogoContent = ( { ...props.primitive || {}, ...position.data } ) as LogoContent 
    const style: CSSProperties = {
        color: primitive.style?.color || primitive.text_color,
        fontSize: primitive.style?.fontSize
    }
    
    return !!primitive.src || !!primitive.title
        ?
        <LinkContainer
            link_url={primitive.link_url}
            link_target={primitive.link_target}
            className={`landing-link ${ primitive.vertical ? "vertical": "" } link-${ primitive.id }`} 
            data-primitive-type={primitive["data-primitive-type"]}
        >    
            {
                !!primitive.src 
                ?
                 <img 
                    src={primitive.src} 
                    alt="logo" 
                    width={primitive.width || "auto"} 
                    height={primitive.height || "auto"} 
                    className={primitive.className || ""}
                    style={{
                        maxWidth: primitive.width
                    }}
                /> 
                :
                <></>
            }           
            <div className={`flex-grow-100 ml-3 ${ primitive.vertical ? "flex-centered flex-column": "" }`} style={style}>
                {
                    !!primitive.title && <div className={`title mb-2 pointer `} style={{ ...primitive.titleStyle }} dangerouslySetInnerHTML={{__html: primitive.title}} />
                }
                {
                    !!primitive.description && <div className="mb-1" style={primitive.descriptionStyle} dangerouslySetInnerHTML={{__html: primitive.description}} />
                } 
                {
                    !!primitive.commentary && <div className="opacity_75 small letter-spacing-2"  style={primitive.commentaryStyle} dangerouslySetInnerHTML={{__html: primitive.commentary }} /> 
                } 
            </div>
        </LinkContainer>
        :
        <></> 
}
export default LogoPrimitive